<!-- 用户登录成功后的主页，所有页面内容均通过该页面加载而来 -->
<template>
  <div class="app-container">
    <!-- 主页顶部菜单栏 tab-->
    <app-top-navigation></app-top-navigation>
    <!-- 除主菜单栏之外的展示区域，该区域包含左侧菜单栏及右侧内容区域 -->
    <section class="main-view-section">
      <!-- 主页左侧菜单栏 -->
      <app-left-navigation
        ref="leftMenu"
        @loadSysMenu="loadSysMenu"
      ></app-left-navigation>
      <!-- 主内容展示区域，包已打开页签列表及内容区域 -->
      <div class="main-content-area">
        <!-- <div class="main-content-bg main-blur-panel"></div> -->
        <!-- 已打开页签列表展示区域 -->
        <app-menu-tabs></app-menu-tabs>
        <!-- 内容主区域，所有子页面均展示在该区域中 -->
        <div
          class="main-content-container"
          v-if="isRouterAlive && keepAliveRouter.indexOf($route.name) == -1"
        >
          <keep-alive>
            <router-view
              v-if="$route.meta.routerAlive && keepAliveRouter.indexOf($route.name) == -1"
            />
          </keep-alive>
          <router-view
            v-if="!$route.meta.routerAlive && keepAliveRouter.indexOf($route.name) == -1"
          />
          <!-- 全局通用的手动告警 -->
          <miniAlarm
            ref="miniAlarmPanel"
            :showAlarmPanel="showMiniAlarmPanel"
            class="miniAlarm"
            :miniAlarmStyle="miniAlarmStyle"
            @handleClosePanel="handleCloseMiniAlarm"
            :info="miniAlarmInfo"
          ></miniAlarm>
        </div>

        <!--单独的页面缓存 比如：视频监控  v-if="showPlayVue"-->
        <template v-for="item in keepAliveVue">
          <div
            :key="item.label"
            class="main-content-container live"
            v-show="item.label == $route.name"
          >
            <component :is="showPlayCom(item)"></component>
            <!-- 全局通用的手动告警 -->
            <miniAlarm
              v-if="item.label == $route.name"
              ref="miniAlarmPanel"
              :showAlarmPanel="showMiniAlarmPanel"
              class="miniAlarm"
              :miniAlarmStyle="miniAlarmStyle"
              @handleClosePanel="handleCloseMiniAlarm"
              :info="miniAlarmInfo"
            ></miniAlarm>
          </div>
        </template>
        <!-- 主页面区域的遮罩层，提供全局方法供业务页面使用 -->
        <!-- 地图引入 -->
        <div id="global-map-container" :class="['map-view', mapVisible ? 'show' : '']">
          <appMap ref="appMap" @mapReady="mapReady"></appMap>
        </div>
        <div
          v-if="!hideContentCover"
          :class="['content-cover', showContentCover ? 'show' : '']"
        ></div>
      </div>
    </section>
    <!-- 视频巡逻弹窗 -->
    <app-scoket-dialog
      v-if="appScoketDialogIsShow"
      ref="socketWindow"
    ></app-scoket-dialog>
    <notice-panel
      :info="firstObject"
      :deviceName="firstObject.deviceName"
      :alarmLevel="firstObject.alarmLevel"
      :alarmTime="firstObject.alarmTime"
      :alarmId="firstObject.alarmId"
      :subSystem="firstObject.subSystem"
      :alarmType="firstObject.alarmType"
      :right="firstObject.right"
      :matchType="firstObject.matchType"
      :areaName="firstObject.areaName"
      :matchTime="firstObject.matchTime"
      :matchRecordCode="firstObject.matchRecordCode"
      :alarmAudioUrl="firstObject.alarmAudioUrl"
      :bottom="firstObject.bottom"
      :commonAlarmType="firstObject.commonAlarmType"
      key-object="firstObject"
      @closeMessage="handleCloseMessage"
    ></notice-panel>
    <notice-panel
      :info="secObject"
      :deviceName="secObject.deviceName"
      :alarmTime="secObject.alarmTime"
      :alarmLevel="secObject.alarmLevel"
      :alarmType="secObject.alarmType"
      :alarm-id="secObject.alarmId"
      :subSystem="secObject.subSystem"
      :right="secObject.right"
      :matchType="secObject.matchType"
      :areaName="secObject.areaName"
      :matchTime="secObject.matchTime"
      :matchRecordCode="secObject.matchRecordCode"
      :alarmAudioUrl="secObject.alarmAudioUrl"
      :commonAlarmType="secObject.commonAlarmType"
      :bottom="secObject.bottom"
      key-object="secObject"
      @closeMessage="handleCloseMessage"
    ></notice-panel>
    <notice-panel
      :info="thrObject"
      :commonAlarmType="thrObject.commonAlarmType"
      :deviceName="thrObject.deviceName"
      :alarmTime="thrObject.alarmTime"
      :alarmLevel="thrObject.alarmLevel"
      :alarmType="thrObject.alarmType"
      :alarm-id="thrObject.alarmId"
      :subSystem="thrObject.subSystem"
      :right="thrObject.right"
      :matchType="thrObject.matchType"
      :areaName="thrObject.areaName"
      :matchTime="thrObject.matchTime"
      :matchRecordCode="thrObject.matchRecordCode"
      :alarmAudioUrl="thrObject.alarmAudioUrl"
      :bottom="thrObject.bottom"
      key-object="thrObject"
      @closeMessage="handleCloseMessage"
    ></notice-panel>
    <!--推荐使用 全局单窗口统一调用该播放器 -->
    <!-- <miniPlayer ref="videoPlayer" v-if="miniPlayerShow" /> -->
    <dhWindowPlayer ref="videoPlayer" v-if="miniPlayerShow"></dhWindowPlayer>
    <!--特殊场景：及时播放 需要支持2个窗口同时播放时使用-->
    <miniPlayer ref="videoPlayerDialog" v-if="miniPlayerShowDialog" :immediate="true" />

    <!-- 视频播放插件安装弹窗 -->
    <el-dialog
      :title="'插件安装提示!'"
      width="480px"
      style="margin-top:10%; !important;"
      :close-on-click-modal="false"
      :visible.sync="isDownload"
      :before-close="handleClose"
    >
      <label
        >检测到您尚未安装客户端视频插件或安装包有问题，为优化您的使用，请下载并安装客户端视频插件!</label
      >
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="handleClose" type="info">取 消</el-button>
        <el-button size="mini" type="primary" @click="appDownload">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 图片放大镜 -->
    <viewer @inited="inited" :images="viewerPhotos" class="viewer" ref="viewer">
      <img v-for="src in viewerPhotos" :src="src" :key="src" />
    </viewer>
  </div>
</template>
<script>
import videoMonitoring from "@src/modules/videoMonitoring/view/index.vue";
import videoBack from "@src/modules/videoBack/view/index.vue";
import miniPlayer from "@components/mini-player/mini-player.vue";
import dhWindowPlayer from "@src/components/business/dh-window-player/index.vue";
import miniAlarm from "@components/mini-player/mini-alarm.vue";
import appMap from "@src/components/common/gis/index";
import appTopNavigation from "@src/components/common/app-nav/app-top-navigation";
import appLeftNavigation from "@src/components/common/app-nav/app-left-navigation";
import appMenuTabs from "@src/components/common/app-nav/app-menu-tabs";
import webScoket from "@src/common/utils/webScoket.js";
import appScoketDialog from "@src/components/common/app-dialog/app-scoket-dialog";
import NoticePanel from "@src/components/common/app-dialog/app-alarm-dialog";
import { Dic, Cache, Bus, Base, Dates } from "$utils";
export default {
  components: {
    appTopNavigation,
    appLeftNavigation,
    appMenuTabs,
    appScoketDialog,
    NoticePanel,
    appMap,
    miniPlayer,
    dhWindowPlayer,
    miniAlarm,
    videoMonitoring,
    videoBack,
  },
  data() {
    return {
      keepAliveRouter: ["videoMonitoringIndex", "videoBackIndex"],
      keepAliveVue: [
        {
          label: "videoMonitoringIndex",
          value: "/videoMonitoring",
          com: "videoMonitoring",
        },
        { label: "videoBackIndex", value: "/videoBack", com: "videoBack" },
      ],
      zindex: 2,
      miniAlarmStyle: {},
      miniAlarmInfo: {},
      showMiniAlarmPanel: false, //手动告警侧边栏
      playInfo: {},
      viewerInstance: null,
      viewerPhotos: [],
      miniPlayerShow: false,
      miniPlayerShowDialog: false,
      mapVisible: false,
      // oldParams
      isRouterAlive: true,
      showContentCover: false,
      iconObj: {
        media: "icon-shibie1",
        production: "icon-shibieshuai",
        administrator: "icon-renyuanguanli1",
        security: "icon-jiankong",
        pass: "icon-shibie2",
        situation: "icon-zhuye",
        facilities: "icon-tongxingjilu",
      },
      systemList: [
        {
          menuIcon: "iconfont-menu iconshibiezhongxin",
          subsystemName: "识别中心",
          path: "/access/identifyCenter",
        },
      ],
      appScoketDialogIsShow: false,
      alarmDialog: [],
      alarmName: "",
      timer: null,
      firstObject: {
        key: "",
        deviceName: "",
        alarmLevel: 1,
        alarmType: "",
        visible: false,
        right: -346, //通过该属性控制显示和隐藏
        alarmAudioUrl: "",
        bottom: 10,
        alarmId: null,
        subSystem: "",
        commonAlarmType: "",
      },
      secObject: {
        key: "",
        deviceName: "",
        alarmLevel: 1,
        alarmType: "",
        alarmAudioUrl: "",
        visible: false,
        right: -346,
        bottom: 175,
        alarmId: null,
        subSystem: "",
        commonAlarmType: "",
      },
      thrObject: {
        key: "",
        deviceName: "",
        alarmLevel: 1,
        alarmAudioUrl: "",
        alarmType: "",
        visible: false,
        right: -346,
        bottom: 345,
        alarmId: null,
        subSystem: "",
        commonAlarmType: "",
      },
      alertAlarmData: [],
      cashAlarmData: [],
      messageArr: [],
      hideContentCover: true,
      maxTipNum: 3,
    };
  },
  computed: {
    isDownload() {
      return this.$store.getters.isDownload || false;
    },
    // 用来判断非keep-alive页面的缓存组件处理逻辑
    showPlayVue() {
      let menuList = this.$store.getters.menuTabsList || [];
      return menuList.some((el) => {
        return el.path == "/videoMonitoring";
      });
    },
  },
  watch: {
    alarmDialog: "getDialog",
    // $route: {
    //   handler(val) {
    //     if (val.name == "videoMonitoringIndex") {
    //       this.zindex = 0;
    //     } else {
    //       this.zindex = 2;
    //     }
    //   },
    //   immediate: true,
    // },
  },
  beforeRouteEnter: (to, from, next) => {
    if (to.path == "/security/home" && to.query.type == 0) {
      next({
        path: "/pagenotfound",
        query: {
          type: "暂无权限，请联系管理员！",
        },
      });
    } else {
      next();
    }
  },
  created() {
    this.$store.dispatch("GetSysOptions");
    this.$app.setAppInstance({
      reload: () => {
        this.reload();
      },
      showMap2D: () => {
        console.log("地图显示");
        this.mapVisible = true;
        if (this.$refs.appMap) {
          this.$refs.appMap.setMapCenter();
          this.$refs.appMap.setMapZoom(18);
          this.$refs.appMap.clearOverlays();
          this.$refs.appMap.getAreaInfo();
        }
      },
      hideMap2D: () => {
        console.log("地图隐藏");
        if (this.mapVisible == true) {
          this.$refs.appMap.addClickEvent();
          this.$refs.appMap.setMapCenter();
          this.$refs.appMap.setMapZoom(18);
          this.$refs.appMap.clearOverlays();
          // this.$refs.appMap.getAreaInfo();
        }
        this.handleMiniPlay();
        this.handleMiniPlayDialog();
        this.handleMiniReportAlarm();
        this.mapVisible = false;
      },
    });
    this.getAlarmCount();
  },
  mounted() {
    this.initPlay();
    const appInstance = this.$app.AppInstance;
    window.addEventListener("load", webScoket.initWebSocket(this), false);
    this.$app.setAppInstance({
      ...appInstance,
      /**
       * [showCover 展示内容区域的遮罩层]
       * @return {[Null]} [无]
       */
      showCover: () => {
        if (this.hideCoverTimer) {
          clearTimeout(this.hideCoverTimer);
        }
        this.showContentCover = true;
        this.hideContentCover = false;
      },
      /**
       * [hideCover 隐藏内容区域的遮罩层]
       * @return {[Null]} [无]
       */
      hideCover: () => {
        if (this.hideCoverTimer) {
          clearTimeout(this.hideCoverTimer);
        }
        this.showContentCover = false;
        this.hideCoverTimer = setTimeout(() => {
          this.hideContentCover = true;
        }, 200);
      },
      /**
       * [refresh 主内容区域刷新方法，主要将主内容区域销毁再重新加载，触发主内容区域的所有页面初始化]
       * @return {[Null]} [无]
       */
      refresh: () => {
        this.isRouterAlive = false;
        this.$nextTick(() => {
          this.isRouterAlive = true;
        });
      },
      // 清除告警弹窗
      clearAlarm: () => {
        this.cashAlarmData = [];
        this.alertAlarmData = [];
      },
      // 触发播放器
      handleMiniPlay: (options) => {
        // 有参数表示播放  没有参数表示关闭
        this.handleMiniPlay(options);
      },
      // 触发播放器即时播放
      handleMiniPlayDialog: (options) => {
        // 有参数表示播放  没有参数表示关闭
        this.handleMiniPlayDialog(options);
      },
      // 触发上报告警
      handleMiniReportAlarm: (options, styleOptions) => {
        this.handleMiniReportAlarm(options, styleOptions);
      },
      // 触发图片放大镜
      handleShowViewer: (src) => {
        this.handleShowViewer(src);
      },
      // 触发插件登录，初始化
      // handleInitPlay: (callBack) => {
      //   if (!this.playInfo) {
      //     this.getPlayInfo(callBack);
      //     return;
      //   }
      //   this.handlePlayLogin(callBack);
      // },
      handleInitPlay: () => {},
    });
  },

  methods: {
    showPlayCom(item) {
      let list = this.$store.getters.menuTabsList;
      if (
        list &&
        list.some((el) => {
          return el.path == item.value;
        })
      ) {
        return item.com;
      }
    },
    inited(viewer) {
      this.viewerInstance = viewer;
    },
    //图片放大镜
    handleShowViewer(src) {
      this.viewerPhotos = [...src];
      this.viewerInstance.show();
    },
    // 关闭上报告警
    handleCloseMiniAlarm() {
      this.miniAlarmStyle = {};
      this.miniAlarmInfo = {};
      this.showMiniAlarmPanel = false;
    },
    // 上报告警
    handleMiniReportAlarm(options, styleOptions) {
      if (!options) {
        this.handleCloseMiniAlarm();
        return;
      }
      if (this.showMiniAlarmPanel) {
        this.$refs.miniAlarmPanel.handleClosePanel();
        setTimeout(() => {
          this.handleMiniReportAlarm(options);
        }, 500);
        return;
      }
      this.miniAlarmInfo = options;
      this.miniAlarmStyle = styleOptions;
      this.showMiniAlarmPanel = true;
    },
    // 视频播放
    handleMiniPlay(options) {
      if (!options) {
        if (this.$refs.videoPlayer && this.$refs.videoPlayer.showPage) {
          this.$refs.videoPlayer.handleClose();
        }
        return;
      }
      this.miniPlayerShow = true;
      if (this.$refs.videoPlayer && this.$refs.videoPlayer.showPage) {
        this.$refs.videoPlayer.handleClose();
        setTimeout(() => {
          this.$refs.videoPlayer.showWnd(options);
        }, 500);
        return;
      }
      this.$nextTick(() => {
        this.$refs.videoPlayer.showWnd(options);
      });
    },
    // 视频播放-即时播放
    handleMiniPlayDialog(options) {
      if (!options) {
        if (this.$refs.videoPlayerDialog && this.$refs.videoPlayerDialog.showPage) {
          this.$refs.videoPlayerDialog.handleClose();
        }
        return;
      }
      this.miniPlayerShowDialog = true;
      if (this.$refs.videoPlayerDialog && this.$refs.videoPlayerDialog.showPage) {
        this.$refs.videoPlayerDialog.handleClose();
        setTimeout(() => {
          this.$refs.videoPlayerDialog.showWnd(options);
        }, 500);
        return;
      }
      this.$nextTick(() => {
        this.$refs.videoPlayerDialog.showWnd(options);
      });
    },
    handleClose() {
      this.$store.commit("SET_ISDownload", false);
    },
    appDownload() {
      // window.location.href = "/app/VideoWebPlugin.exe";
      var aLink = document.createElement("a");
      aLink.style.display = "none";
      aLink.download = "监控视频播放器.msi";
      aLink.href = "http://" + this.playInfo.ip + "/ActiveX/WEBPlayer.msi";
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
      this.handleClose();
    },
    // 初始化播放器相关信息
    initPlay() {
      // this.getPlayInfo();
      // window.systemConfig.LOAD_PLAY && this.monitorPlay();
    },
    // 获取播放器厂家信息
    getPlayInfo(callBack) {
      this.$fetch(this.$api.common.playInfo, {
        pageNum: 1,
        pageSize: 100,
        systemId: "200000014",
      }).then((res) => {
        if (res.success) {
          let playInfo = res.returnObj.list[0];
          this.$store.commit("SET_PlayInfo", playInfo);
          this.playInfo = { ...playInfo };
          this.handlePlayLogin(callBack);
        } else {
          this.$message.error("获取播放器信息失败");
          this.$store.commit("SET_isInitPlay", false);
        }
      });
    },
    // 检测播放器是否打开
    monitorPlay(isDown = false) {
      let that = this;
      if (!imosSdk) {
        setTimeout(() => {
          this.monitorPlay();
        }, 3000);
        return;
      }
      imosSdk.checkOutWebPlayer().then(function (res) {
        console.log(res);
        if (res.ErrCode == 0) {
          that.$store.commit("SET_ISDownload", false);
        } else {
          if (isDown) {
            that.$store.commit("SET_ISDownload", true);
          } else {
            // 打开本地播放器
            that.handleStartPlay();
          }
        }
      });
    },
    handleStartPlay() {
      let iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = "imos://startXPWebPlayer";
      let openTime = setTimeout(() => {
        clearTimeout(openTime);
        this.monitorPlay(true);
      }, 5000);
      iframe.onload = () => {
        // 5S之后清除
        let timer = setTimeout(() => {
          clearTimeout(timer);
          document.body.removeChild(iframe);
        }, 5000);
      };
      document.body.appendChild(iframe);
    },
    // 登录插件
    handlePlayLogin(callBack) {
      this.$fetchVideo("/VIID/login/v2").then((res) => {
        let username = this.playInfo.userName; //"liusuo"
        let password = this.playInfo.password; //"MapMap123"
        var accessCode = res.AccessCode;
        var md1 = forge.md.md5.create(); //md5
        var md2 = forge.md.md5.create(); //md5
        md1.update(password); //md5
        var passwordMd5 = md1.digest().toHex(); //md5
        var base64Username = window.btoa(username);
        var loginSignatureTemp = base64Username + accessCode + passwordMd5;
        md2.update(loginSignatureTemp); //md5
        var loginSignature = md2.digest().toHex(); //md5
        var data = {
          UserName: username,
          AccessCode: accessCode,
          LoginSignature: loginSignature,
        };
        this.$fetchVideo("/VIID/login/v2", data).then((response) => {
          let loginResult = response.data?.ErrCode;
          switch (
            loginResult //判断返回值：12351是‘用户不存在’；50004是‘密码错误，登录失败’
          ) {
            case 50004:
              this.$message.error("密码错误");
              break;
            case 12351:
              this.handlePlayLogin(callBack);
              this.$message.error("用户不存在");
              break;
            case undefined:
              window.token = response.AccessToken;
              this.handleInitVideo(callBack);
              break;
          }
        });
      });
    },
    // 初始化插件
    handleInitVideo(callBack) {
      let that = this;
      imosSdk
        .init(this.playInfo.ip, window.token, 16, "imosSdk.html", true)
        .then(function (res) {
          console.log("视频插件初始化成功", res, imosSdk);
          that.$store.commit("SET_isInitPlay", true);
          callBack && callBack(); //执行非主页面的验证登录回调函数
        })
        .catch(function (err) {
          that.$store.commit("SET_isInitPlay", false);
          // that.handleInitVideo(callBack);
          console.log("视频插件初始化失败", err, imosSdk);
        });
    },

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    mapReady() {
      // this.$refs.appMap.initMap();
      this.$map.setMapInstance2D(this.$refs.appMap);
      // window.eventBus.$emit('map2DReady');
      console.log("3地图对象注册到全局", this.$map);
      this.$map.mapReady();
    },
    getAlarmCount() {
      this.$fetch("/bas/alarmSafeEvent/queryRealAlarmCount.json").then((res) => {
        if (res.success) {
          this.$store.commit("SET_ALARM_COUNT", res.returnObj.realAlarmCount || 0);
        } else {
          this.$log.error("查询系统告警总数失败，错误信息为：", res);
        }
      });
    },
    loadSysMenu(ids) {
      //
    },
    getDialog(data) {
      // 告警
      this.maxTipNum = data.matchType ? 1 : 3;
      if (this.alertAlarmData.length < this.maxTipNum) {
        this.alertMessage(data);
        return;
      }
      this.cashAlarmData.push(data);
    },
    // 告警弹出框
    alertMessage(alarmData) {
      //  debugger
      if (!alarmData) return;
      if (alarmData.matchType) {
        // 识别中心
        this.alertAlarmData.push(alarmData.matchRecordCode);
      } else {
        this.alertAlarmData.push(alarmData.alarmId);
      }
      this.handleMessageScheduling(alarmData);
      // console.log('告警弹出框',this.alertAlarmData);
    },
    // 弹出告警窗口
    alertAlarmWindow(key, message) {
      this.messageArr.push(key);
      this[key].key = message.key;
      if (message.matchType) {
        // 识别中心
        this[key].areaName = message.areaName; //识别中心位置
        this[key].matchRecordCode = message.matchRecordCode; //识别id
        this[key].matchType = message.matchType; //类型
        this[key].matchTime = message.matchTime; //时间
        this[key].right = -346;
      } else {
        let showfile = "ALARM_LEVEL_" + message.alarmLevel + "_VOICE_FLAG";
        let voiceData = Cache.get("SYS_VOICE");
        voiceData.forEach((el, index) => {
          if (el.cfgCode == showfile) {
            if (el.cfgValue == "true") {
              // 判断消防还是实时告警
              let name = "";
              if (message.subSystem != 4) {
                // 安防告警声音
                name = "ALARM_LEVEL_" + message.alarmLevel + "_VOICE_FILE";
              } else {
                if (message.commonAlarmType != "4001") {
                  name = "FIREFIGHTING_ALARM_LEVEL_" + message.alarmLevel + "_VOICE_FILE";
                } else {
                  // 火警用单独的声音播放
                  name = "FIREFIGHTING_FIRE_VOICE_FILE";
                }
              }
              console.info("name====", name);
              let checkData = voiceData.filter((item) => {
                return item.cfgCode == name;
              });
              this[key].alarmAudioUrl = checkData[0].cfgValue; //消防voic
              // console.log(this[key].alarmAudioUrl)
            }
          }
        });
        this[key].deviceName = message.alarmName || message.deviceName; //告警名称
        this[key].alarmId = message.alarmId;
        this[key].subSystem = message.subSystem;
        this[key].alarmType = message.alarmType;
        this[key].commonAlarmType = message.commonAlarmType;
        this[key].alarmTime = message.alarmTime; //告警时间
        this[key].alarmLevel = message.alarmLevel; //告警级别
        //消防和安防都有弹窗
        if (message.key == "FIREFIGHTINGALARM" || message.key == "ALARM") {
          this[key].right = 8;
        } else {
          // 隐藏弹窗
          this[key].right = -346;
        }
        //告警声音的播放机制加持
        let audioName = "#alarmAudio" + this[key].bottom;
        var audio = document.querySelector(audioName);
        // console.log(audio)
        // 如果此处的位置弹窗音乐没有播放完成，稍后0.5秒执行，建议弹窗消失，告警声音关闭---建议建议
        if (audio.paused) {
          audio.play();
        } else {
          audio && audio.paused();
          setTimeout(() => {
            audio && audio.play();
          }, 500);
        }
      }
      // 告警弹窗显示定时器
      this.setTimeShow(key, message);
    },
    // 告警中心推送消息调度控制
    handleMessageScheduling(alarmData) {
      // console.log('----tuison0----', alarmData);
      if (!this.messageArr.some((item) => item === "firstObject")) {
        this.alertAlarmWindow("firstObject", alarmData);
        return;
      }
      if (!this.messageArr.some((item) => item === "secObject")) {
        this.alertAlarmWindow("secObject", alarmData);
        return;
      }
      if (!this.messageArr.some((item) => item === "thrObject")) {
        this.alertAlarmWindow("thrObject", alarmData);
        return;
      }
    },
    // 关闭告警窗口
    handleCloseMessage(alarmId, key) {
      // this[key].visible = false;
      this[key].right = -346;
      this.messageArr = this.messageArr.filter((item) => item !== key);
      this.alertAlarmData = this.alertAlarmData.filter((item) => {
        return item !== alarmId;
      });
      if (this.cashAlarmData.length > 0 && this.alertAlarmData.length < this.maxTipNum) {
        this.alertMessage(this.cashAlarmData[0]);
        this.cashAlarmData.splice(0, 1);
      }
    },
    setNoticeShow(key, message) {
      // this[key].visible = false;
      this[key].right = -346;
      this.messageArr = this.messageArr.filter((item) => item !== key);
      this.alertAlarmData = this.alertAlarmData.filter((item) => {
        if (message.matchType) {
          // 识别中心
          return item !== message.matchRecordCode;
        } else {
          // 告警
          return item !== message.alarmId;
        }
      });
      if (this.cashAlarmData.length > 0 && this.alertAlarmData.length < this.maxTipNum) {
        setTimeout(() => {
          this.alertMessage(this.cashAlarmData[0]);
          this.cashAlarmData.splice(0, 1);
        }, 3200);
      }
    },
    // 此处建立时间机制
    setTimeShow(key, data) {
      if (key == "firstObject") {
        let message = data;
        setTimeout(
          () => {
            this.setNoticeShow(key, message);
          },
          this.maxTipNum == 1 ? 3000 : 5200
        );
        return;
      }
      if (key == "secObject") {
        let message2 = data;
        setTimeout(() => {
          this.setNoticeShow(key, message2);
        }, 5100);
        return;
      }
      if (key == "thrObject") {
        let message3 = data;
        setTimeout(() => {
          this.setNoticeShow(key, message3);
        }, 5000);
        return;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~@src/common/assets/style/mixin";

/* 首页内容区域样式 */
.app-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;

  .main-view-section {
    flex: 1;
    overflow: hidden;
    display: flex;
    min-height: 0;

    .main-content-area {
      @include set_theme_color(background-color, page-default-bg);
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      position: relative;
      width: 0;

      .main-content-bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
      }

      .page-padding {
        padding: 12px 16px 0 16px;
      }

      .page-margin {
        margin: 12px 16px 0 16px;
      }

      .main-content-container {
        flex: 1;
        height: 0;
        position: relative;
        // @include set_theme_color(background-color, page-bg-color);
        margin: 0;
        display: flex;
        overflow: hidden;
      }

      .main-content-index {
        z-index: 1;
        width: 100%;
        position: absolute;
        height: 100%;
        top: 0px;
        display: flex;
        background-color: #0d121c;
      }

      .content-cover {
        position: absolute;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 1);
        @include set_animation(opacity);
        opacity: 0;

        // &.show {
        //   opacity: 0.4;
        // }
      }
    }
  }
}

/* 页面需要分左右区域时，使用该样式，如左侧为设备或区域树，右边为内容主区域，使用该样式来进行布局 */
.page-main-container {
  position: relative;
  height: 100%;
  width: 100%;
  margin: 0;
  overflow: hidden;

  /* 左侧内容区域 */
  .left-area {
    position: absolute;
    width: 240px;
    top: 0;
    left: 0;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
  }

  /* 右侧内容主区域 */
  .main-area {
    position: relative;
    margin-left: 250px;
    width: calc(100% - 250px);
    height: 100%;
    overflow-y: auto;
    overflow-x: auto;
  }
}
</style>
